import { render, staticRenderFns } from "./SlaServiceWizard.vue?vue&type=template&id=70e11c36&"
import script from "./SlaServiceWizard.vue?vue&type=script&lang=js&"
export * from "./SlaServiceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports